<template>
    <v-content pa-0>
        <Header></Header>
        <v-layout justify-start :style="$vuetify.breakpoint.mdAndUp ? { 'padding-top': '88px' } : {}">
            <v-flex class="headTab" py-3 px-5>
                <img class="mx-5" width="auto" height="35px" :src="require('../assets/icon/report.png')">
                <div class="text-start">
                    {{ $t('data-and-statistic') }}
                </div>
            </v-flex>
        </v-layout>
        <v-layout justify-start pa-5>
            <v-icon @click="goBack">arrow_back_ios</v-icon>
        </v-layout>
        <v-layout justify-center>
            <v-flex xs10>
                <v-layout mb-10
                    :class="{ 'column': $vuetify.breakpoint.smAndDown, 'align-center': $vuetify.breakpoint.smAndDown }">
                    <v-flex shrink>
                        <v-layout pa-5
                            :class="{ 'column': $vuetify.breakpoint.smAndDown, 'mx-5': $vuetify.breakpoint.mdAndUp }">
                            <v-flex shrink mr-7>
                                <v-select v-model="statistic.selectedYear" :items="selectYear" color="#FF5100"
                                    :style="$vuetify.breakpoint.smAndDown ? { 'width': '100%' } : { 'width': '250px' }"
                                    :label="$t('general.year')" hide-details outlined></v-select>
                            </v-flex>

                            <v-flex shrink mr-7 v-if="!isLoading">
                                <v-select v-model="selectedIndustry.selectedIndustry"
                                    :disabled="detailGraph.topic_id != 1" :items="industries" color="#FF5100"
                                    :style="$vuetify.breakpoint.smAndDown ? { 'width': '100%' } : { 'width': '250px' }"
                                    :label="$t('general.select-industry')" hide-details outlined></v-select>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                    <v-flex shrink style="display: flex;align-items: center">
                        <v-layout justify-center :class="{ 'column': $vuetify.breakpoint.xs }">
                            <v-flex shrink pt-3 :class="{ 'mr-7': $vuetify.breakpoint.smAndUp }">
                                <v-btn class="white--text" style="width: 100px" color="#FF5100"
                                    @click.prevent="initData()">{{ $t('search') }}
                                </v-btn>
                            </v-flex>
                            <v-flex shrink pt-3 style="cursor: pointer" :class="{ 'pt-7': $vuetify.breakpoint.xs }"
                                @click="window.open(exportPdfLink, '_blank');">
                                <v-btn small depressed fab class="mx-2" color="#FF5100">
                                    <v-icon class="white--text">get_app</v-icon>
                                </v-btn>
                                <span>
                                    {{ $t('saveFile') }}
                                </span>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>

            </v-flex>
        </v-layout>
        <loading :active.sync="isLoading"></loading>
        <v-layout justify-center v-if="!isLoading">
            <v-flex xs11>
                <template v-if="detailGraph.graph[`labels_${language}`].length">
                    <v-layout justify-start pa-5 class="barTab">
                        <v-flex shrink px-5 text-start>
                            {{ detailGraph[`title_${language}`] }}
                            {{ $t('general.as-per-year') }}
                            {{ yearFormat(detailGraph.latestyear, $i18n.locale) }}
                        </v-flex>
                    </v-layout>
                    <template v-if="detailGraph.graph[`labels_${language}`].length > 1">
                        <!-- Sorting -->
                        <v-layout justify-start pa-5>
                            <v-flex text-right class="text-right">

                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-btn class="mx-2" fab :dark="statistic.graphDetail.graphSort === ''"
                                            :color="statistic.graphDetail.graphSort === '' ? '#FF5100' : 'light'"
                                            v-on="on" @click="setGraphSort(''); initData();">
                                            <v-icon dark>close</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>{{ $t('general.sort.none') }}</span>
                                </v-tooltip>

                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-btn class="mx-2" fab :dark="statistic.graphDetail.graphSort === 'asc'"
                                            :color="statistic.graphDetail.graphSort === 'asc' ? '#FF5100' : 'light'"
                                            v-on="on" @click="setGraphSort('asc'); initData();">
                                            <v-icon dark>mdi-sort-ascending</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>{{ $t('general.sort.ascending') }}</span>
                                </v-tooltip>

                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-btn class="mx-2" fab :dark="statistic.graphDetail.graphSort === 'desc'"
                                            :color="statistic.graphDetail.graphSort === 'desc' ? '#FF5100' : 'light'"
                                            v-on="on" @click="setGraphSort('desc'); initData();">
                                            <v-icon dark>mdi-sort-descending</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>{{ $t('general.sort.descending') }}</span>
                                </v-tooltip>
                            </v-flex>
                        </v-layout>

                        <!-- Chart -->
                        <v-layout column justify-center>
                            <v-flex>
                                <HBarChart class="mb-5" :chartdata="detailGraph.graph[`labels_${language}`]"
                                    :options="detailGraph.graph.values" dataname="Value"
                                    :unit="detailGraph.topic.data_query[0].index.unit[`name_${language}`]"></HBarChart>
                            </v-flex>
                        </v-layout>
                    </template>

                    <template v-else>
                        <v-layout column justify-center pt-3>
                            <v-flex my-5>
                                <img :src="selectedCategoryIcon">
                            </v-flex>
                            <v-flex my-10 style="font-size: 70px; font-weight: bold">
                                {{ formatNumber(detailGraph.graph.values) }}
                            </v-flex>
                            <v-flex mb-3>
                                {{ $t('general.million-baht') }}
                            </v-flex>
                            <v-flex mb-3 style="font-size: 20px; font-weight: bold">
                                {{ detailGraph[`title_${language}`] }} {{ $t('general.as-per-year') }} {{
                                    detailGraph.latestyear }}
                            </v-flex>
                            <v-flex mb-3>
                                <template v-if="detailGraph.graph.tsic_code">
                                    {{ detailGraph.graph.tsic_code[0] + ' : ' +
                                        detailGraph.graph[`labels_${language}`][0] }}
                                </template>
                            </v-flex>
                        </v-layout>
                    </template>

                    <template v-if="detailGraph.link_data_url">
                        <div class="text-left pa-5">
                            {{ $t('general.reference') }}:
                            <span @click="openLink(detailGraph.link_data_url)" class="txt-link">
                                <template v-if="detailGraph[`reference_text_${language}`]">
                                    <span>{{ detailGraph[`reference_text_${language}`] }}</span>
                                </template>
                                <template v-else>
                                    <span>{{ detailGraph.link_data_url }}</span>
                                </template>
                            </span>
                        </div>
                    </template>
                </template>

                <template v-else>
                    <v-layout>
                        <v-flex>
                            <h2 class="mb-10">{{ $t('page.graph-detail.error.graph-no-data') }}</h2>
                        </v-flex>
                    </v-layout>
                </template>

                <template v-if="!detailGraph.is_hide_detail_table">
                    <v-layout justify-start pa-5 class="barTab">
                        <v-flex shrink px-5 text-start>
                            <template v-if="selectedIndustry.selectedIndustry">
                                {{ $t('page.graph-detail.annual-creative-industry-value-grouped', {
                                    year:
                                        yearFormat(detailGraph.latestyear, $i18n.locale)
                                }) }}
                            </template>
                            <template v-else>
                                {{ detailGraph[`title_${language}`] }}
                                {{ $t('general.as-per-year') }}
                                {{ yearFormat(detailGraph.latestyear, $i18n.locale) }}
                            </template>
                        </v-flex>
                    </v-layout>

                    <v-layout>
                        <v-flex class="mb-10">
                            <TwoColumnsTableData :data="detailGraph.data_table"
                                :unit="detailGraph.topic.data_query[0].index.unit[`name_${language}`]">
                            </TwoColumnsTableData>
                        </v-flex>
                    </v-layout>
                </template>
            </v-flex>
        </v-layout>

        <v-layout justify-start>
            <v-flex class="headTab" py-3 px-5>
                <img class="mx-5" width="auto" height="35px" :src="require('../assets/icon/report.png')">
                <div class="text-start">
                    {{ $t('related-research-report') }}
                </div>
            </v-flex>
        </v-layout>

        <v-layout justify-center>
            <v-flex xs12>
                <ReportGroup group="industries" :list="articlesList"></ReportGroup>
            </v-flex>
        </v-layout>

        <Footer></Footer>
    </v-content>
</template>

<script>
import Header from '../components/Header';
import Footer from '../components/Footer';
import BarChart from '../components/BarChart';
import HBarChart from '../components/HBarChart';
import TableData from '../components/TableData';
import TwoColumnsTableData from '../components/TwoColumnsTableData';
import Service from '../services';
import Loading from 'vue-loading-overlay';
import { mapState, mapActions } from 'vuex';
import { domain } from '../services/Constants';
import ReportGroup from '../components/ReportGroup';
import { yearFormat } from "../utils/Utils"

export default {
    components: {
        Header,
        Footer,
        // eslint-disable-next-line vue/no-unused-components
        BarChart,
        HBarChart,
        // eslint-disable-next-line vue/no-unused-components
        TableData,
        TwoColumnsTableData,
        Loading,
        ReportGroup
    },
    props: ['statistic_id', 'industry_id', 'year'],
    data: () => ({
        http: domain,
        selectCategory: [],
        selectedCategoryIcon: '',
        barData: {},
        barLoaded: true,

        HbarLoaded: true,
        isLoading: true,
        articlesList: [],
        industriesIcon: [
            { id: 1, selected: true, title: 'งานฝีมือและหัตถกรรม', img_file: 'manufacture.png' },
            { id: 2, selected: false, title: 'ดนตรี', img_file: 'music.png' },
            { id: 3, selected: false, title: 'ศิลปะการแสดง', img_file: 'show.png' },
            { id: 4, selected: false, title: 'ทัศนศิลป์', img_file: 'visual-arts.png' },
            { id: 5, selected: false, title: 'ภาพยนตร์', img_file: 'film.png' },
            { id: 6, selected: false, title: 'การแพร่ภาพและกระจายเสียง', img_file: 'telecom.png' },
            { id: 7, selected: false, title: 'การพิมพ์', img_file: 'document.png' },
            { id: 8, selected: false, title: 'ซอฟต์แวร์', img_file: 'software.png' },
            { id: 9, selected: false, title: 'การโฆษณา', img_file: 'advertise.png' },
            { id: 10, selected: false, title: 'การออกแบบ', img_file: 'design.png' },
            { id: 11, selected: false, title: 'การให้บริการด้านสถาปัตยกรรม', img_file: 'blueprint.png' },
            { id: 12, selected: false, title: 'แฟชัน', img_file: 'fashion.png' },
            { id: 13, selected: false, title: 'อาหารไทย', img_file: 'thai-food.png' },
            { id: 14, selected: false, title: 'การแพทย์แผนไทย', img_file: 'thai-medicine.png' },
            { id: 15, selected: false, title: 'การท่องเที่ยวเชิงวัฒนธรรม', img_file: 'culture-tour.png' },
        ],
        yearFormat: yearFormat,
        window: window
    }),
    watch: {
        language: function () {
            // Force reload
            this.isLoading = true
            this.$nextTick(() => {
                this.isLoading = false
            })
        }
    },
    async created() {
        // Google analytic page view
        Service.analytics.sendPageView({
            path: this.$route.path
        })

        if (this.industry_id) {
            this.$store.dispatch('statistic/setGraphDetailSelectedIndustry', parseInt(this.industry_id))
        }
        // Service.chartdata.getChartData(this.$route.params.id,this.$route.params.year).then((res) => {
        //     console.log(res[0]);
        //     this.barData = res[0];
        // }).then(() => {
        //     setTimeout(() => {
        //         this.isLoading = false;
        //         this.barLoaded = true;
        //         console.log('barData',this.barData)
        //     },300);
        // });
        Service.webdata.getArticles().then(res => {
            this.articlesList = res.data.map(item => {
                return { ...item, img_cover_path: domain + '/' + item.img_cover_path }
            })
        })


        // Service.chartdata.getAllChartData()
        //     .then((res) => {
        //         this.selectCategory = res;
        //         this.selectYear = res[0].year;
        //         this.selectCategory.unshift({industry: 'ทั้งหมด', id: 'ทั้งหมด'});
        //     })

        await this.populateAvailableYear()
        this.populateIndustries()
        this.initData()
    },
    computed: {
        ...mapState({
            searchedData: state => state.searchedChart.industrySearched,
            allIndustries: state => state.searchedChart.industryType,
            graphLoaded: state => state.searchedChart.stateLoaded,

            industries: function (state) {

                return [
                    {
                        value: null,
                        text: this.$i18n.t('general.select-industry')
                    },
                    ...state.industry.industries.map(industry => ({
                        value: industry.id,
                        text: industry[`name_${state.locale.language}`],
                        icon_path: industry.icon_path
                    }))
                ]
            },
            statistic: state => state.statistic,
            selectYear: function (state) {
                return state.statistic.availableYears.map((year) => {
                    return {
                        text: this.yearFormat(year, this.$i18n.locale),
                        value: year
                    }
                })
            },
            selectedYear: state => state.statistic.selectedYear,
            detailGraph: state => {
                state.statistic.graphDetail.graph.labels_th = state.statistic.graphDetail.graph.labels_th.map(label => label.split('\n'))
                state.statistic.graphDetail.graph.labels_en = state.statistic.graphDetail.graph.labels_en.map(label => label.split('\n'))
                return state.statistic.graphDetail
            },
            selectedIndustry: state => state.statistic.graphDetail,
            language: state => state.locale.language,
        }),
        exportPdfLink() {
            const link = `${this.http}/preview-export-pdf?statistic_id=${this.statistic_id}&year_data=${this.selectedYear}&industry_id=${this.selectedIndustry.selectedIndustry}`
            return link
        }
    },
    methods: {
        ...mapActions("searchedChart", ["searchedDataIndustry", "searchedAllIndustryByYear", "setIndustryType", "setLoadState"]),
        ...mapActions("statistic", ["populateDetail", "populateAvailableYear", "setGraphSort"]),
        ...mapActions("industry", ["populateIndustries"]),
        async initData() {
            this.isLoading = true
            await this.populateDetail(this.statistic_id)

            this.selectedCategoryIcon = this.selectedIndustry.selectedIndustry && this.industries[this.selectedIndustry.selectedIndustry].icon_path
                ? domain + '/' + this.industries[this.selectedIndustry.selectedIndustry].icon_path
                : '';

            this.isLoading = false
        },
        spaceSplit(text) {
            text.split(' ').then(res => {
                return res[1];
            })
        },
        formatNumber(num) {
            console.log({ num: num })
            console.log({ toString: num.toString() })
            return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
        },
        goBack() {
            this.$router.go(-1)
        },
        // oneData (label) {
        //     console.log(label)
        //     let oneIndustry = this.industries.find(function(item) {
        //         return item.name_th === label;
        //     });
        //     return oneIndustry.icon_path;
        // },

        pushSearch() {
            if (this.searchedData.id === undefined || this.searchedData.id === null || this.searchedData.id === '' ||
                this.searchedData.year === undefined || this.searchedData.year === null || this.searchedData.year === '') {

                alert('กรุณาเลือกหมวดหมู่และปีที่ต้องการแสดงข้อมูล');

            } else if (this.searchedData.id === 'ทั้งหมด') {

                this.HbarLoaded = false;
                this.isLoading = true;
                this.setLoadState(false);
                this.setIndustryType(true);
                this.searchedAllIndustryByYear(this.searchedData.year).then(() => {
                    setTimeout(() => {
                        this.searchedData.id = 'ทั้งหมด'
                        this.isLoading = false
                        this.HbarLoaded = true
                        this.setLoadState(true)
                    }, 400)
                })

            } else {

                this.barLoaded = false;
                this.isLoading = true;
                this.setLoadState(false);

                let categories = this.selectCategory;

                for (let i = 0; i < categories.length; i++) {
                    if (this.searchedData.id === categories[i].id) {
                        // Service.chartdata.getChartData(categories[i].id,this.searchedData.year).then((res) => {
                        //     console.log(res[0]);
                        //     this.searchedData = res[0];
                        // }).then(() => {
                        //     setTimeout(() => {
                        //         this.isLoading = false;
                        //         this.barLoaded = true;
                        //         console.log('searchedData',this.searchedData)
                        //     },300);
                        // });
                        this.setIndustryType(false);
                        this.searchedDataIndustry({ id: categories[i].id, year: this.searchedData.year }).then(() => {
                            setTimeout(() => {
                                this.isLoading = false;
                                this.barLoaded = true;
                                this.setLoadState(true);
                            }, 400);
                        });
                    }
                }

            }

        },
        openLink(url) {
            if (url) {
                if (url.split('.')[0] === 'www') {
                    window.open(`https://${url}`);
                } else {
                    window.open(url);
                }
            }
        }
    }
}
</script>

<style scoped>
.headTab {
    background: #000;
    color: #fff;
    text-transform: uppercase;
    font-size: 20px;
    display: flex;
    align-items: center;
}

.barTab {
    background: #4F4F4F;
    color: #fff;
    font-size: 20px;
}

/*.v-slide-group__next, .v-slide-group__prev {*/
/*    min-width: 10px !important;*/
/*}*/
</style>
